module.exports = __webpack_public_path__ + "static/img/IMG@2x.f7fb533.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/IMG@2x.png
// module id = UYVv
// module chunks = 2